import { LoadingState } from '../loading-state.js';

export class AppState {
  public readonly currentStep: number;
  public readonly loadingState: {
    isLoading: boolean;
    isFailed: boolean;
  };
  public readonly reservationSuccessful: boolean | null;

  constructor(
    currentStep = -1,
    loadingState: { isLoading: boolean; isFailed: boolean } = LoadingState.loading(),
    reservationSuccessful: boolean | null = null,
  ) {
    this.currentStep = currentStep;
    this.loadingState = loadingState;
    this.reservationSuccessful = reservationSuccessful;
  }

  public nextStep(): AppState {
    if (this.currentStep < 4) {
      return new AppState(this.currentStep + 1, this.loadingState, this.reservationSuccessful);
    }
    return this;
  }

  public prevStep(): AppState {
    if (this.currentStep > 0) {
      return new AppState(this.currentStep - 1, this.loadingState, this.reservationSuccessful);
    }
    return this;
  }

  public goToFirstStep(): AppState {
    return new AppState(0, this.loadingState, this.reservationSuccessful);
  }

  public goToStoreSelectionStep(): AppState {
    return new AppState(2, this.loadingState, this.reservationSuccessful);
  }

  public withLoadingState(loadingState: { isLoading: boolean; isFailed: boolean }): AppState {
    return new AppState(this.currentStep, loadingState, this.reservationSuccessful);
  }

  public setLoading(): AppState {
    return this.withLoadingState(LoadingState.loading());
  }

  public setLoaded(): AppState {
    return this.withLoadingState(LoadingState.loaded());
  }

  public setLoadedWithError(): AppState {
    return this.withLoadingState(LoadingState.loadedWithError());
  }

  public setReservationStatus(successful: boolean): AppState {
    return new AppState(this.currentStep, this.loadingState, successful);
  }

  public static reset(): AppState {
    return new AppState();
  }
}
